import { connect } from 'react-redux';
import {
    emitMessage
} from 'src/modules/Modal';

import {
    fetchLastBill,
    selectLastBill
} from 'src/modules/Restaurant';

import {
    selectSessionError,
    selectOrderContext
} from 'src/modules/Order';

const mapDispatchToProps = {
    emitMessage,
    fetchLastBill
};

const mapStateToProps = (state) => ({
    sessionError: selectSessionError(state),
    context: selectOrderContext(state),
    lastBill: selectLastBill(state)
});

export default connect(mapStateToProps, mapDispatchToProps);
